import { useCallback } from 'react';
import { useNavComponentsManager } from './useNavComponentsManager';
export const useInvokeFunction = (definition, __definitionParams) => {
  const {
    handleInvokeFunction
  } = useNavComponentsManager();
  const invoke = useCallback((fnName, args) => {
    return handleInvokeFunction(definition, fnName, args);
  }, [definition, handleInvokeFunction]);
  return {
    invoke
  };
};